import React, { useState } from "react";
import { Formik, Form, Field, validateYupSchema } from "formik";
import { FaSearch } from "react-icons/fa";
import Select from "react-select";

import FormInputLayout from "./FormInputLayout";
import PlainButton from "./buttons/PlainButton";
import Filtericon from "../assets/misc/filtericn.png";
import { colourStyles } from "../data/Constants";
import DatePickerInput from "./DatePicker/DatePicker";
import { toast } from "react-toastify";
import { CERTIFICATE_STATUS, CERTIFICATE_STATUS_LABELS_VALUES, TechnologyFieldsOptions } from "../data/NewApplicantsConstants";
import Modal from "./Modal";
import { useDispatch, useSelector } from "react-redux";
import { CPD_SUBMISSION_STATUS_CONSTANT, TypeOfCPDActivities } from "../data/CpdSubmissionConstants";
import DatePicker from "react-multi-date-picker";
import moment from "moment";
import { useLocation, useNavigate } from "react-router-dom";
import { formatDateForDisplay } from "../utils/HelperFunctions";
import ApplicationReadyForAssessmentForm from "./ApplicationReadyForAssessmentForm";
import { newApplicantsService } from "../services/newApplicantsService";
import { atpUsersService } from "../services/atpUsersService";
import ATPForm from "../pages/ATP/Pages/Listings/partials/ATPForm";
import { handleLoading, setBulkCPDStatusChange, setFirstSelectedStatus, setIDforStatusChange } from "../redux/slices/generalSlice";
import StatusBatchUpdater from "./UpdateStatusAll";
import { membershipService } from "../services/membershipService";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { cpdSubmissionService } from "../services/cpdSubmissionService";
import BulkStatusApplicantUpdate from "./UpdateStatusAllAplicants";
import BulkAppealStatusUpdate from "./BulkAppealStatusUpdate";
import { appealsService } from "../services/appealsService";
import { AppealStatus } from "../data/AppealsConstants";

const Filter = ({
    handleFilter,
    openModal,
    closeModal,
    modalRef,
    showModal,
    initialValues,
    setInitialValues,
    handleSearch,
    fieldsToDisplay,
    userType,
    allAtpActivitiesData,
    fetchData,
    fetchAllAplicantsData,
    fetchAppealsData,
    fetchRefundAll,
    loading,
    currentCPDStatus,
    getCpdSubmissionList,
}) => {
    const search = useSelector((state) => state.newApplicants.search);
    const changeIDsStatus = useSelector((state) => state?.general?.selectedIDforStatusChange);
    const [readyForAssessmentPopup, setReadyForAssessmentPopup] = useState(false);
    const [statusBatchPopup, setStatusBatchPopup] = useState(false);
    const [statusApplicantBatchPopup, setStatusApplicantBatchPopup] = useState(false);
    const [statusAppealPopup, setStatusAppealPopup] = useState(false);
    const [showCreateATPModal, setShowCreateATPModal] = useState(false);
    const firstSelectedStatus = useSelector((state) => state?.general?.firstSelectedStatus);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const MySwal = withReactContent(Swal);
    const location = useLocation();
    const certificateType = useSelector((state) => state.newApplicants.certificateType);
    const activeStatusTab = useSelector((state) => state.newApplicants.certificateStatus);
    const selectedIDforStatusChange = useSelector((state) => state.general.selectedIDforStatusChange[0]);
    const firstSelectedCategory = useSelector((state) => state?.general?.firstSelectedCategory);
    const handleSubmit = (values, search) => {
        if (Object.values(values).every((value) => value?.toString()?.trim() === "")) {
            toast.error("Please select at least one option.");
        } else {
            handleFilter(values, search);
            closeModal();
        }
    };

    const openReadyForAssessmentModal = () => {
        setReadyForAssessmentPopup(true);
        document.body.style.overflow = "hidden";
    };

    const closeReadyForAssessmentModal = () => {
        setReadyForAssessmentPopup(false);
        document.body.style.overflow = "auto";
    };

    const openStatusApplicantModal = (firstSelectedStatus) => {
        // If the status is not restricted, proceed to open the modal
        setStatusApplicantBatchPopup(true);
        document.body.style.overflow = "hidden";
    };

    const closeStatusApplicantModal = () => {
        setStatusApplicantBatchPopup(false);
        document.body.style.overflow = "auto";
    };

    const openStatusBatchModal = () => {
        setStatusBatchPopup(true);
        document.body.style.overflow = "hidden";
    };

    const closeStatusBatchModal = () => {
        setStatusBatchPopup(false);
        document.body.style.overflow = "auto";
    };

    const openAppealStatusModal = () => {
        setStatusAppealPopup(true);
        document.body.style.overflow = "hidden";
    };

    const closeAppealStatusModal = () => {
        setStatusAppealPopup(false);
        document.body.style.overflow = "auto";
    };

    const handleReset = () => {
        setInitialValues({
            full_name: "",
            registered_from: "",
            registered_to: "",
            board_approval_from: "",
            board_approval_to: "",
            email: "",
            filter_status: "",
            registration_no: "",
            technology_field: "",
            payment_from: "",
            payment_to: "",
            assessment_from: "",
            assessment_to: "",
            identity_number: "",
            payment_status: "",
            search: "",
            company_name: "",
            certificate_type: "",
            organization: "",
            submission_date: null,
            interview_date: null,
        });
        closeModal();
        // allAtpActivitiesData()
        handleFilter();
        handleSearch("");
    };

    const handleSubmitReadyForAssessmentReason = async (values) => {
        const data = {
            ids: changeIDsStatus,
            session_date: values?.session_date ? moment(values.session_date).format("YYYY-MM-DD") : undefined,
            slots: values?.slots,
            // technology_field: values?.technology_field,
            panelists: values?.panelist,
            secretariat: values?.secretariat,
        };
        try {
            // setLoading(true);
            const response = await newApplicantsService.assessmentSchedule(data);
            toast.success(response?.data?.message);
            document.body.style.overflow = "auto";
            setReadyForAssessmentPopup(false);
            dispatch(setIDforStatusChange([]));
            fetchAllAplicantsData();
            fetchData();
            navigate("/new-applicants");
            // setIsOpen(false);
            // setRejectionPopup(false);
        } catch (error) {
            toast.error(error?.response?.data?.message);
        } finally {
            // setLoading(false);
        }
    };

    const handleSubmitATPUserCreate = async (values) => {
        // dispatch(handleLoading(true))
        try {
            const data = {
                name: values.name,
                email: values.email,
                company_name: values.company_name,
            };
            // Make the API call
            await atpUsersService.createATPUserManually(data);
            // dispatch(handleLoading(false))

            toast.success("CPD activity submitted successfully!"); // Optional success message
        } catch (error) {
            // Display error message from the response
            toast.error(error?.response?.data?.message || "An error occurred while submitting.");
            // dispatch(handleLoading(false))
        }
    };

    const handleUpdateStatusBulk = async (values) => {
        const MemberShipdata = {
            ids: changeIDsStatus,
            status:
                typeof values?.status === "number"
                    ? values.status
                    : values?.status === "DEREGISTERED"
                        ? CERTIFICATE_STATUS.DEREGISTERED
                        : values?.status === "REMOVAL_DEATH"
                            ? CERTIFICATE_STATUS.REMOVAL_DEATH
                            : null,
            ...(values?.approval_date && { approval_date: moment(values.approval_date).format("YYYY-MM-DD") }),
            ...(values?.refund_date && { refund_date: moment(values.refund_date).format("YYYY-MM-DD") }),
            ...(values?.other_reason && { other_reason: values.other_reason }),
            ...(values?.appeal_board_date && { appeal_board_date: moment(values.appeal_board_date).format("YYYY-MM-DD") }),
            ...(values?.secretariat_reason && { secretariat_reason: values.secretariat_reason }),
        };

        const CPDData = {
            user_cpd_ids: changeIDsStatus.map(Number),
            user_cpd_status:
                values?.status === "PENDING"
                    ? CPD_SUBMISSION_STATUS_CONSTANT.PENDING
                    : values?.status === "SUBMITTED"
                        ? CPD_SUBMISSION_STATUS_CONSTANT.SUBMITTED
                        : values?.status === "APPROVED"
                            ? CPD_SUBMISSION_STATUS_CONSTANT.APPROVED
                            : values?.status === "REJECTED"
                                ? CPD_SUBMISSION_STATUS_CONSTANT.REJECTED
                                : values?.status === "KIV"
                                    ? CPD_SUBMISSION_STATUS_CONSTANT.KIV
                                    : values?.status === "INCOMPLETE_DOCUMENT"
                                        ? CPD_SUBMISSION_STATUS_CONSTANT.INCOMPLETE_DOCUMENT
                                        : null,
            ...(values.cpd_hours ? { awarded_cpd: Number(values.cpd_hours) } : {}),
            ...(values.decision_committee_date ? { decision_committee_date: values.decision_committee_date } : {}),
            ...(values.reason ? { reason: values.reason } : {}),
        };

        try {
            if (location.pathname == "/membership-status" || location.pathname == "/new-applicants" || location.pathname == "/refund-cases") {
                const response = await membershipService.updateBulkMembershipStatus(MemberShipdata);
                if (location.pathname == "/new-applicants") {
                    navigate("/new-applicants");
                    fetchAllAplicantsData();
                    fetchData();
                    dispatch(setIDforStatusChange([]));
                    dispatch(setFirstSelectedStatus(null));
                }
                if (location.pathname == "/refund-cases") {
                    navigate("/refund-cases");
                    fetchRefundAll();
                    dispatch(setIDforStatusChange([]));
                    dispatch(setFirstSelectedStatus(null));
                }
                if (location.pathname == "/membership-status") {
                    navigate("/membership-status");
                }
            }
            if (location.pathname == "/cpd-submission") {
                try {
                    dispatch(handleLoading(true))
                    const response = await cpdSubmissionService.updateBulkCPDStatus(CPDData);
                    dispatch(setBulkCPDStatusChange(response?.data?.data));
                    getCpdSubmissionList();
                    dispatch(setIDforStatusChange([]));
                    dispatch(setFirstSelectedStatus(null));
                    dispatch(handleLoading(false))
                } catch (error) {
                    console.error("Error updating bulk CPD status:", error);
                    // Optionally, dispatch an action or show a notification for the error
                    // dispatch(setErrorNotification("Failed to update CPD status."));
                }
                finally{
                    dispatch(handleLoading(false))
                }
            }
            setStatusBatchPopup(false);
            setStatusApplicantBatchPopup(false);
            toast.success("Status Updated successfully!");
        } catch (error) {
            toast.error(error);
        } finally {
        }
    };
    const handleSubmitWithConfirmation = async (values) => {
        // Define max hours for each CPD type in a mapping
        const maxHoursMapping = {
            1: 12, 2: 12, 3: 12, 4: 8, 5: 12,
            6: 10, 7: 10, 8: 10, 9: 10, 10: 10,
            11: 15, 12: 15, 13: 15, 14: 10, 15: 10,
            16: 15, 17: 5, 18: 5,
        };

        // Ensure firstSelectedCategory is defined and values.cpd_hours is a valid number
        if (firstSelectedCategory && values?.cpd_hours > maxHoursMapping[firstSelectedCategory]) {
            // If cpd_hours exceeds the maximum for the selected category
            toast.error(`The CPD hours exceed the maximum allowed for this category (${maxHoursMapping[firstSelectedCategory]} hours).`)
            return;
        }
        setStatusApplicantBatchPopup(false);
        setStatusBatchPopup(false);
        const { isConfirmed } = await MySwal.fire({
            title: "Are you sure you want to change the status?",
            icon: "question",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes",
            didClose: () => {
                setStatusBatchPopup(false); // Close handler
                setStatusApplicantBatchPopup(false);
                document.body.style.overflow = "auto";
                dispatch(setFirstSelectedStatus(null));
            },
        });

        if (isConfirmed) {
            handleUpdateStatusBulk(values);
        }
    };
    const handleAppealStatusWithConfirmation = async (values) => {
        const AppealData = {
            ids: changeIDsStatus,
            status: values.status,
        };
        // Add the approval or rejection date based on the status
        if (values.status == AppealStatus.APPROVED) {
            AppealData.approval_date = values.approval_date && moment(values.approval_date).format("YYYY-MM-DD"); // Include approval_date if status is approved
        } else if (values.status == AppealStatus.REJECTED) {
            AppealData.rejection_date = values.rejection_date && moment(values.rejection_date).format("YYYY-MM-DD"); // Include rejection_date if status is rejected
        }
        setStatusAppealPopup(false);
        const { isConfirmed } = await MySwal.fire({
            title: "Are you sure you want to change the status?",
            icon: "question",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes",
            didClose: () => {
                setStatusAppealPopup(false); // Close handler
                document.body.style.overflow = "auto";
            },
        });

        if (isConfirmed) {
            try {
                if (location.pathname == "/appeals") {
                    const response = await appealsService.changeBulkAppealStatus(AppealData);
                    setStatusAppealPopup(false);
                    toast.success("Status Updated successfully!");
                    fetchAppealsData();
                }
            } catch (error) {
                toast.error(error);
            } finally {
                dispatch(setIDforStatusChange([]));
                dispatch(setFirstSelectedStatus(null));
            }
        }
    };

    return (
        <>
            {showCreateATPModal && <ATPForm handleClose={() => setShowCreateATPModal(false)} handleSubmit={handleSubmitATPUserCreate} />}
            {readyForAssessmentPopup && <ApplicationReadyForAssessmentForm closePopup={closeReadyForAssessmentModal} handleSubmit={handleSubmitReadyForAssessmentReason} id={selectedIDforStatusChange} />}
            {statusApplicantBatchPopup && <BulkStatusApplicantUpdate closePopup={closeStatusApplicantModal} handleSubmit={handleSubmitWithConfirmation} />}
            {statusBatchPopup && <StatusBatchUpdater closePopup={closeStatusBatchModal} handleSubmit={handleSubmitWithConfirmation} currentCPDStatus={currentCPDStatus} />}
            {statusAppealPopup && <BulkAppealStatusUpdate closePopup={closeAppealStatusModal} handleSubmit={handleAppealStatusWithConfirmation} />}
            <div className="d-flex filterx w-100">
                <div className="filteritm">
                    <Formik initialValues={initialValues} enableReinitialize={true}>
                        <Form>
                            <div className="search">
                                <span className="fa-search">
                                    <FaSearch />
                                </span>
                                <Field onClick={openModal} type="text" name="search" className="form-control" autoComplete="off" placeholder="Search Here.." />
                            </div>
                        </Form>
                    </Formik>
                </div>
                <div className="d-flex gap-3 align-items-center">
                    {changeIDsStatus?.length > 0 && location.pathname == "/new-applicants" && (certificateType == "3" || certificateType == "4") && activeStatusTab == "26" ? (
                        <PlainButton className="next_btn" type="submit" onClick={openReadyForAssessmentModal}>
                            Ready for Assessment
                        </PlainButton>
                    ) : (
                        changeIDsStatus?.length > 0 &&
                        (location.pathname == "/new-applicants" || location.pathname == "/refund-cases") &&
                        !((certificateType == "3" || certificateType == "4") && activeStatusTab == "26") && (
                            <PlainButton className="next_btn" type="submit" onClick={() => openStatusApplicantModal(firstSelectedStatus)}>
                                Update Applicant Status
                            </PlainButton>
                        )
                    )}
                    {changeIDsStatus?.length > 0 && location.pathname == "/cpd-submission" && (
                        <PlainButton className="next_btn" type="submit" onClick={openStatusBatchModal}>
                            Update CPD Status
                        </PlainButton>
                    )}
                    {changeIDsStatus?.length > 0 && location.pathname == "/membership-status" && (
                        <PlainButton className="next_btn" type="submit" onClick={openStatusBatchModal}>
                            Update Membership Status
                        </PlainButton>
                    )}
                    {changeIDsStatus?.length > 0 && location.pathname == "/appeals" && (
                        <PlainButton className="next_btn" type="submit" onClick={openAppealStatusModal}>
                            Update Appeal Status
                        </PlainButton>
                    )}
                    {location.pathname === "/atp" && (
                        <PlainButton className="next_btn" type="submit" onClick={() => setShowCreateATPModal(true)}>
                            Add ATP
                        </PlainButton>
                    )}
                    <div>
                        <img onClick={openModal} src={Filtericon} />
                    </div>
                </div>
            </div>

            {showModal && (
                <div className="filterpopup">
                    <Modal closeModal={closeModal} modalRef={modalRef} showModal={showModal} className="filterpopup">
                        <div className="">
                            <div className="d-flex filterx">
                                <div className="filteritm">
                                    <Formik initialValues={initialValues}>
                                        <Form>
                                            <div className="search">
                                                <span className="fa-search">
                                                    <FaSearch />
                                                </span>
                                                <Field
                                                    type="text"
                                                    name="title"
                                                    className="form-control"
                                                    autoComplete="off"
                                                    placeholder="Search Here.."
                                                    value={search}
                                                    onChange={(e) => handleSearch(e.target.value)}
                                                />
                                            </div>
                                        </Form>
                                    </Formik>
                                </div>
                                <div>
                                    <img onClick={openModal} src={Filtericon} />
                                </div>
                            </div>
                            <Formik initialValues={initialValues} onSubmit={(values) => handleSubmit({ ...values, search: search })}>
                                {({ setFieldValue, values }) => (
                                    <Form className="stepper-form-container">
                                        <div className="d-flex gap-3 filterMobView">
                                            {fieldsToDisplay?.approval_status && (
                                                <div className="flex-1">
                                                    <FormInputLayout label="Approval Status" formikName="scheme" required={false}>
                                                        <Select
                                                            isSearchable={false}
                                                            styles={colourStyles}
                                                            components={{
                                                                IndicatorSeparator: () => null,
                                                            }}
                                                        />
                                                    </FormInputLayout>
                                                </div>
                                            )}
                                            {fieldsToDisplay?.full_name && (
                                                <div className="flex-1">
                                                    <FormInputLayout label={userType === 3 || location.pathname === "/activities" ? "Pic Name" : "Full Name"} formikName="full_name" required={false}>
                                                        <Field type="text" name="full_name" className="form-control mb-2" autoComplete="off" placeholder="Enter Name" />
                                                    </FormInputLayout>
                                                </div>
                                            )}
                                            {fieldsToDisplay?.identity_number && (
                                                <div className="flex-1">
                                                    <FormInputLayout label="No. IC/Passport" formikName="identity_number" required={false}>
                                                        <Field type="text" name="identity_number" className="form-control mb-2" autoComplete="off" placeholder="No. IC/Passport" />
                                                    </FormInputLayout>
                                                </div>
                                            )}
                                            {/* {fieldsToDisplay?.registered_to_from && (
                        <div className="flex-1">
                          <FormInputLayout
                            label="Registered Date"
                            formikName="registered_from"
                            required={false}
                          >
                            <div className="d-flex gap-3">
                              <div className="flex-1 ">
                                <DatePickerInput
                                  formikName="registered_from"
                                  setFieldValue={setFieldValue}
                                  value={values?.registered_from}
                                  placeholder="From"
                                />
                              </div>
                              <div className="flex-1">
                                <DatePickerInput
                                  formikName="registered_to"
                                  setFieldValue={setFieldValue}
                                  value={values?.registered_to}
                                  placeholder="To"
                                />
                              </div>
                            </div>
                          </FormInputLayout>
                        </div>
                      )} */}

                                            {fieldsToDisplay?.submission_date && (
                                                <div className="flex-1">
                                                    <FormInputLayout label="Submission Date" formikName="submission_date" required={false}>
                                                        <div className="d-flex gap-3">
                                                            <div className="flex-1 ">
                                                                <DatePickerInput
                                                                    formikName="submission_date"
                                                                    setFieldValue={setFieldValue}
                                                                    value={values?.submission_date}
                                                                    placeholder="Submission Date"
                                                                />
                                                            </div>
                                                        </div>
                                                    </FormInputLayout>
                                                </div>
                                            )}
                                        </div>
                                        <div className="d-flex gap-3 filterMobView">
                                            {fieldsToDisplay?.filter_status && (
                                                <div className="flex-1">
                                                    <FormInputLayout label="Status" formikName="filter_status" required={false}>
                                                        <Select
                                                            isSearchable={false}
                                                            options={CERTIFICATE_STATUS_LABELS_VALUES}
                                                            styles={colourStyles}
                                                            components={{
                                                                IndicatorSeparator: () => null,
                                                            }}
                                                            onChange={(valueObj) => setFieldValue("filter_status", valueObj?.value)}
                                                            value={CERTIFICATE_STATUS_LABELS_VALUES.find((option) => option.value === values?.filter_status)}
                                                        />
                                                    </FormInputLayout>
                                                </div>
                                            )}
                                            {fieldsToDisplay?.interview_date && (
                                                <div className="flex-1">
                                                    <FormInputLayout label="Interview Date" formikName="interview_date" required={false}>
                                                        <div className="d-flex gap-3">
                                                            <div className="flex-1 ">
                                                                <DatePickerInput
                                                                    formikName="interview_date"
                                                                    setFieldValue={setFieldValue}
                                                                    value={values?.interview_date}
                                                                    placeholder="Interview Date"
                                                                />
                                                            </div>
                                                        </div>
                                                    </FormInputLayout>
                                                </div>
                                            )}
                                            {fieldsToDisplay?.technology_field && (
                                                <div className="flex-1">
                                                    <FormInputLayout label="Field of Technology" formikName="technology_field" required={false}>
                                                        <Select
                                                            isSearchable={false}
                                                            styles={colourStyles}
                                                            options={TechnologyFieldsOptions}
                                                            onChange={(valueObj) => setFieldValue("technology_field", valueObj?.value)}
                                                            value={TechnologyFieldsOptions.find((option) => option.value === values?.technology_field)}
                                                            components={{
                                                                IndicatorSeparator: () => null,
                                                            }}
                                                        />
                                                    </FormInputLayout>
                                                </div>
                                            )}
                                            {/* {fieldsToDisplay?.payment_status && (
                        <div className="flex-1">
                          <FormInputLayout
                            label="Payment Status"
                            formikName="payment_status"
                            required={false}
                          >
                            <Select
                              isSearchable={false}
                              styles={colourStyles}
                              components={{
                                IndicatorSeparator: () => null,
                              }}
                            />
                          </FormInputLayout>
                        </div>
                      )} */}
                                            {/* {fieldsToDisplay?.identity_number && (
                        <div className="flex-1">
                          <FormInputLayout
                            label="No. IC/Passport"
                            formikName="identity_number"
                            required={false}
                          >
                            <Field
                              type="text"
                              name="identity_number"
                              className="form-control mb-2"
                              autoComplete="off"
                              placeholder="No. IC/Passport"
                            />
                          </FormInputLayout>
                        </div>
                      )} */}
                                            {fieldsToDisplay?.organization && (
                                                <div className="flex-1">
                                                    <FormInputLayout label="Organisation" formikName="organization" required={false}>
                                                        <Field type="text" name="organization" className="form-control mb-2" autoComplete="off" placeholder="Enter organisation" />
                                                    </FormInputLayout>
                                                </div>
                                            )}
                                            {/* {fieldsToDisplay?.certificate_type && (
                        <div className="flex-1">
                          <FormInputLayout
                            label="Field of Technology"
                            formikName="technology_field"
                            required={false}
                          >
                            <Select
                              isSearchable={false}
                              styles={colourStyles}
                              options={TechnologyFieldsOptions}
                              onChange={(valueObj) =>
                                setFieldValue(
                                  "technology_field",
                                  valueObj?.value
                                )
                              }
                              value={TechnologyFieldsOptions.find(
                                (option) =>
                                  option.value === values?.technology_field
                              )}
                              components={{
                                IndicatorSeparator: () => null,
                              }}
                            />
                          </FormInputLayout>
                        </div>
                      )} */}
                                            {fieldsToDisplay?.type_of_cpd && (
                                                <div className="flex-1">
                                                    <FormInputLayout label="CPD Activities Category" formikName="type_of_cpd" required={false}>
                                                        <Select
                                                            isSearchable={false}
                                                            styles={colourStyles}
                                                            options={TypeOfCPDActivities}
                                                            onChange={(valueObj) => setFieldValue("type_of_cpd", valueObj?.value)}
                                                            value={TypeOfCPDActivities.find((option) => option.value === values?.type_of_cpd)}
                                                            components={{
                                                                IndicatorSeparator: () => null,
                                                            }}
                                                        />
                                                    </FormInputLayout>
                                                </div>
                                            )}
                                        </div>
                                        <div className="d-flex gap-3 filterMobView">
                                            {fieldsToDisplay?.registration_no && (
                                                <div className="flex-1">
                                                    <FormInputLayout label="Registration Number" formikName="registration_no" required={false}>
                                                        <Field type="text" name="registration_no" className="form-control mb-2" autoComplete="off" placeholder="Registration No." />
                                                    </FormInputLayout>
                                                </div>
                                            )}
                                            {fieldsToDisplay?.email && (
                                                <div className="flex-1">
                                                    <FormInputLayout label="Email Address" formikName="email" required={false}>
                                                        <Field type="text" name="email" className="form-control mb-2" autoComplete="off" placeholder="Email Address" />
                                                    </FormInputLayout>
                                                </div>
                                            )}
                                        </div>
                                        {/* <div className="d-flex gap-3 filterMobView">
                      <div className="flex-1">
                        <FormInputLayout label="Technology Field" formikName="technology_field" required={false}>
                          <Select
                            isSearchable={false}
                            styles={colourStyles}
                            components={{ IndicatorSeparator: () => null }}
                            options={TechnologyFieldsOptions}
                            onChange={(valueObj) => setFieldValue("technology_field", valueObj?.value)}
                            value={TechnologyFieldsOptions.find((option) => option.value === values?.technology_field)}
                          />
                        </FormInputLayout>
                      </div>
                      <div className="flex-1">
                        <FormInputLayout label="Working Sector" formikName="current_working_sector" required={false}>
                          <Select
                            isSearchable={false}
                            styles={colourStyles}
                            components={{ IndicatorSeparator: () => null }}
                            options={CURRENT_WORKING_SECTOR_LABELS_AND_VALUES}
                            onChange={(valueObj) => setFieldValue("current_working_sector", valueObj?.value)}
                            value={CURRENT_WORKING_SECTOR_LABELS_AND_VALUES.find((option) => option.value === values?.current_working_sector)}
                          />
                        </FormInputLayout>
                      </div>
                    </div> */}
                                        <div className="d-flex gap-3 filterMobView">
                                            {fieldsToDisplay?.board_to_from && (
                                                <div className="flex-1">
                                                    <FormInputLayout label="Board Approval Date" formikName="board_from" required={false}>
                                                        <div className="d-flex gap-3" style={{ width: "75%" }}>
                                                            <div className="flex-1 ">
                                                                <DatePicker
                                                                    value={formatDateForDisplay(values?.board_approval_from, "DD/MM/YYYY", "")}
                                                                    format="DD/MM/YYYY"
                                                                    onChange={(date) => {
                                                                        if (date === null) {
                                                                            setFieldValue("board_approval_from", "");
                                                                        } else {
                                                                            const selectedDate = new Date(date);
                                                                            const formattedDate = moment(selectedDate).format("YYYY-MM-DD");
                                                                            setFieldValue("board_approval_from", formattedDate);
                                                                        }
                                                                    }}
                                                                    maxDate={values.board_approval_to ? moment(values.board_approval_to).toDate() : undefined}
                                                                    placeholder="From"
                                                                    months={["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]}
                                                                />
                                                            </div>
                                                            <div className="flex-1">
                                                                <DatePicker
                                                                    value={formatDateForDisplay(values?.board_approval_to, "DD/MM/YYYY", "")}
                                                                    format="DD/MM/YYYY"
                                                                    onChange={(date) => {
                                                                        if (date === null) {
                                                                            setFieldValue("board_approval_to", "");
                                                                        } else {
                                                                            const selectedDate = new Date(date);
                                                                            const formattedDate = moment(selectedDate).format("YYYY-MM-DD");
                                                                            setFieldValue("board_approval_to", formattedDate);
                                                                        }
                                                                    }}
                                                                    placeholder="To"
                                                                    // minDate={new DateObject({ date: values?.board_from, format: "ddd MMM DD YYYY HH:mm:ss [GMT]ZZ" })}
                                                                    minDate={values.board_approval_from ? moment(values.board_approval_from).toDate() : undefined}
                                                                    months={["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]}
                                                                />
                                                            </div>
                                                        </div>
                                                    </FormInputLayout>
                                                </div>
                                            )}
                                        </div>
                                        <div className="d-flex gap-3 filterMobView">
                                            {fieldsToDisplay?.registered_to_from && (
                                                <div className="flex-1">
                                                    <FormInputLayout label="Registered Date" formikName="registered_from" required={false}>
                                                        <div className="d-flex gap-3" style={{ width: "75%" }}>
                                                            <div className="flex-1 ">
                                                                <DatePicker
                                                                    value={formatDateForDisplay(values?.registered_from, "DD/MM/YYYY", "")}
                                                                    format="DD/MM/YYYY"
                                                                    onChange={(date) => {
                                                                        if (date === null) {
                                                                            setFieldValue("registered_from", "");
                                                                        } else {
                                                                            const selectedDate = new Date(date);
                                                                            const formattedDate = moment(selectedDate).format("YYYY-MM-DD");
                                                                            setFieldValue("registered_from", formattedDate);
                                                                        }
                                                                    }}
                                                                    maxDate={values.registered_to ? moment(values.registered_to).toDate() : undefined}
                                                                    placeholder="From"
                                                                    months={["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]}
                                                                />
                                                            </div>
                                                            <div className="flex-1">
                                                                <DatePicker
                                                                    value={formatDateForDisplay(values?.registered_to, "DD/MM/YYYY", "")}
                                                                    format="DD/MM/YYYY"
                                                                    onChange={(date) => {
                                                                        if (date === null) {
                                                                            setFieldValue("registered_to", "");
                                                                        } else {
                                                                            const selectedDate = new Date(date);
                                                                            const formattedDate = moment(selectedDate).format("YYYY-MM-DD");
                                                                            setFieldValue("registered_to", formattedDate);
                                                                        }
                                                                    }}
                                                                    placeholder="To"
                                                                    // minDate={new DateObject({ date: values?.board_from, format: "ddd MMM DD YYYY HH:mm:ss [GMT]ZZ" })}
                                                                    minDate={values.registered_from ? moment(values.registered_from).toDate() : undefined}
                                                                    months={["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]}
                                                                />
                                                            </div>
                                                        </div>
                                                    </FormInputLayout>
                                                </div>
                                            )}
                                        </div>
                                        <div className="d-flex gap-3 filterMobView">
                                            {fieldsToDisplay?.assessment_to_from && (
                                                <div className="flex-1">
                                                    <FormInputLayout label="Assessment Date" formikName="assessment_from" required={false}>
                                                        <div className="d-flex gap-3" style={{ width: "75%" }}>
                                                            <div className="flex-1 ">
                                                                <DatePicker
                                                                    value={formatDateForDisplay(values?.assessment_from, "DD/MM/YYYY", "")}
                                                                    format="DD/MM/YYYY"
                                                                    onChange={(date) => {
                                                                        if (date === null) {
                                                                            setFieldValue("assessment_from", "");
                                                                        } else {
                                                                            const selectedDate = new Date(date);
                                                                            const formattedDate = moment(selectedDate).format("YYYY-MM-DD");
                                                                            setFieldValue("assessment_from", formattedDate);
                                                                        }
                                                                    }}
                                                                    maxDate={values.assessment_to ? moment(values.assessment_to).toDate() : undefined}
                                                                    placeholder="From"
                                                                    months={["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]}
                                                                />
                                                            </div>
                                                            <div className="flex-1">
                                                                <DatePicker
                                                                    value={formatDateForDisplay(values?.assessment_to, "DD/MM/YYYY", "")}
                                                                    format="DD/MM/YYYY"
                                                                    onChange={(date) => {
                                                                        if (date === null) {
                                                                            setFieldValue("assessment_to", "");
                                                                        } else {
                                                                            const selectedDate = new Date(date);
                                                                            const formattedDate = moment(selectedDate).format("YYYY-MM-DD");
                                                                            setFieldValue("assessment_to", formattedDate);
                                                                        }
                                                                    }}
                                                                    placeholder="To"
                                                                    // minDate={new DateObject({ date: values?.board_from, format: "ddd MMM DD YYYY HH:mm:ss [GMT]ZZ" })}
                                                                    minDate={values.assessment_from ? moment(values.assessment_from).toDate() : undefined}
                                                                    months={["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]}
                                                                />
                                                            </div>
                                                        </div>
                                                    </FormInputLayout>
                                                </div>
                                            )}
                                        </div>

                                        <div className="d-flex gap-3 filterMobView">
                                            {fieldsToDisplay?.company_name && (
                                                <div className="flex-1">
                                                    <FormInputLayout label="Company Name" formikName="company_name" required={false}>
                                                        <Field type="text" name="company_name" className="form-control mb-2 w-50" autoComplete="off" placeholder="Enter Company Name" />
                                                    </FormInputLayout>
                                                </div>
                                            )}
                                        </div>
                                        <div className="d-flex gap-1 filterMobView align-items-center justify-content-start last_input_layout">
                                            <div className="d-flex gap-3 filterMobView">
                                                {fieldsToDisplay?.payment_to_from && (
                                                    <div className="flex-1">
                                                        <FormInputLayout label="Payment Date" formikName="payment_from" required={false}>
                                                            <div className="d-flex gap-3" style={{ width: "75%" }}>
                                                                <div className="flex-1 ">
                                                                    <DatePicker
                                                                        value={formatDateForDisplay(values?.payment_from, "DD/MM/YYYY", "")}
                                                                        format="DD/MM/YYYY"
                                                                        onChange={(date) => {
                                                                            if (date === null) {
                                                                                setFieldValue("payment_from", "");
                                                                            } else {
                                                                                const selectedDate = new Date(date);
                                                                                const formattedDate = moment(selectedDate).format("YYYY-MM-DD");
                                                                                setFieldValue("payment_from", formattedDate);
                                                                            }
                                                                        }}
                                                                        maxDate={values.payment_to ? moment(values.payment_to).toDate() : undefined}
                                                                        placeholder="From"
                                                                        months={["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]}
                                                                    />
                                                                </div>
                                                                <div className="flex-1">
                                                                    <DatePicker
                                                                        value={formatDateForDisplay(values?.payment_to, "DD/MM/YYYY", "")}
                                                                        format="DD/MM/YYYY"
                                                                        onChange={(date) => {
                                                                            if (date === null) {
                                                                                setFieldValue("payment_to", "");
                                                                            } else {
                                                                                const selectedDate = new Date(date);
                                                                                const formattedDate = moment(selectedDate).format("YYYY-MM-DD");
                                                                                setFieldValue("payment_to", formattedDate);
                                                                            }
                                                                        }}
                                                                        placeholder="To"
                                                                        // minDate={new DateObject({ date: values?.board_from, format: "ddd MMM DD YYYY HH:mm:ss [GMT]ZZ" })}
                                                                        minDate={values.payment_from ? moment(values.payment_from).toDate() : undefined}
                                                                        months={["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </FormInputLayout>
                                                    </div>
                                                )}
                                            </div>
                                            {/* {fieldsToDisplay?.board_approval_date && (
                        <div className="flex-1">
                          <FormInputLayout
                            label="Board Approval Date"
                            formikName="scheme"
                          >
                            <div className="d-flex gap-3">
                              <div className="flex-1 ">
                                <Select
                                  isSearchable={false}
                                  styles={colourStyles}
                                  components={{
                                    IndicatorSeparator: () => null,
                                  }}
                                />
                              </div>
                              <div className="flex-1 ">
                                <Select
                                  isSearchable={false}
                                  styles={colourStyles}
                                  components={{
                                    IndicatorSeparator: () => null,
                                  }}
                                />
                              </div>
                            </div>
                          </FormInputLayout>
                        </div>
                      )} */}
                                            <div className="row px-0 mx-0 form-input-container center-alignment">
                                                <div className="right-content d-flex gap-5 justify-content-end btn_css">
                                                    <button className="text-gray-150 fw-500 fs-15 linebtn" onClick={handleReset} type="button">
                                                        Reset Filter
                                                    </button>
                                                    <PlainButton className="next_btn" type="submit">
                                                        Find
                                                    </PlainButton>
                                                </div>
                                            </div>
                                        </div>
                                    </Form>
                                )}
                            </Formik>
                        </div>
                    </Modal>
                </div>
            )}
        </>
    );
};

export default Filter;
